import { createModel } from '@/store/tools';

const model = {
    namespace: 'assignauthority',
    build: (T, A, S, R, C) => ({
        actiontypes: {
            'getlistRoles': T('getlistRoles'),
            'getDeptPullDown': T('getDeptPullDown'),
            'getEmplList': T('getEmplList'),
            'getListEmplsByRole': T('getListEmplsByRole'),
            'getListUnassortedEmpls': T('getListUnassortedEmpls'),
            'getListRoleClass': T('getListRoleClass'),
            'getListCopyRole': T('getListCopyRole'),
            'getCompany': T('getCompany'),
            'getRoleSelect': T('getRoleSelect'),
            'getListRoleByEmpl': T('getListRoleByEmpl'),
            'getListMenuByRole': T('getListMenuByRole'),
        },
        actions: {
            'getlistRoles': A('getlistRoles'),
            'getDeptPullDown': A('getDeptPullDown'),
            'getEmplList': A('getEmplList'),
            'cleanEmplList': C('getEmplList'),
            'getListEmplsByRole': A('getListEmplsByRole'),
            'cleanListEmplsByRole': C('getListEmplsByRole'),
            'getListUnassortedEmpls': A('getListUnassortedEmpls'),
            'getListRoleClass': A('getListRoleClass'),
            'getListCopyRole': A('getListCopyRole'),
            'getCompany': A('getCompany'),
            'getRoleSelect': A('getRoleSelect'),
            'getListRoleByEmpl': A('getListRoleByEmpl'),
            'getListMenuByRole': A('getListMenuByRole'),
            'cleanListMenuByRole': C('getListMenuByRole'),
        },
        sagas: {
            'getlistRoles': S('getlistRoles', '/?cmd=com.xqxc.api.pig.mis.biz.account.RoleMisService.listRoles'),
            'getDeptPullDown': S('getDeptPullDown', '/?cmd=com.xqxc.api.pig.mis.biz.account.DeptMisService.listDeptPullDown'),
            'getEmplList': S('getEmplList', '/?cmd=com.xqxc.api.pig.mis.biz.account.EmplMisService.findEmplPage'),
            'getListEmplsByRole': S('getListEmplsByRole', '/?cmd=com.xqxc.api.pig.mis.biz.account.EmplMisService.listEmplsByRole'),
            'getListUnassortedEmpls': S('getListUnassortedEmpls', '/?cmd=com.xqxc.api.pig.mis.biz.account.EmplMisService.listUnassortedEmpls'),
            'getListRoleClass': S('getListRoleClass', '/?cmd=com.xqxc.api.pig.mis.biz.account.RoleMisService.listRoleClass'),
            'getListCopyRole': S('getListCopyRole', '/?cmd=com.xqxc.api.pig.mis.biz.account.RoleMisService.listCopyRole'),
            'getCompany': S('getCompany', '/?cmd=com.xqxc.api.pig.mis.biz.user.company.CompanyMisService.companyItem'),
            'getRoleSelect': S('getRoleSelect', '/?cmd=com.xqxc.api.pig.mis.biz.account.EmplMisService.listEmpPullDownByRole'),
            'getListRoleByEmpl': S('getListRoleByEmpl', '/?cmd=com.xqxc.api.pig.mis.biz.account.RoleMisService.listRoleByEmpl'),
            'getListMenuByRole': S('getListMenuByRole', '/?cmd=com.xqxc.api.pig.mis.biz.account.MenuMisService.listMenuByRole'),
        },
        reducers: {
            'getlistRoles': R('getlistRoles', {}),
            'getDeptPullDown': R('getDeptPullDown', []),
            'getEmplList': R('getEmplList', { dataList: [], pageNum: 1, pageSize: 30, resultTotal: 0 }),
            'getListEmplsByRole': R('getListEmplsByRole', { dataList: [], pageNum: 1, pageSize: 30, resultTotal: 0 }),
            'getListUnassortedEmpls': R('getListUnassortedEmpls', { dataList: [], pageNum: 1, pageSize: 30, resultTotal: 0 }),
            'getListRoleClass': R('getListRoleClass', []),
            'getListCopyRole': R('getListCopyRole', []),
            'getCompany': R('getCompany', []),
            'getRoleSelect': R('getRoleSelect', []),
            'getListRoleByEmpl': R('getListRoleByEmpl', []),
            'getListMenuByRole': R('getListMenuByRole', []),
        }
    })
};
export default createModel(model);